
import Header from '../componets/headerwebsite/headerweb'
import FooterWeb from '../componets/footerwebsite/footerweb'
import { Button, Card, Form, Input, notification } from 'antd'
import './contactpage.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react'
import { GET, POST } from '../../utils/apicalls'
import { API } from '../../config/api'
import background from "../../assets/background-for-all.png";
import { Col, Row } from 'react-bootstrap'
function Contactpage() {

    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [data, setData] = useState<any>([]);
    const fetchcontactinformation = async () => {
        try {
            setIsLoading(true);
            let api = API.LIST_CONTACT_INFORMATION;
            const response: any = await GET(api, {});

            console.log("API Response:", response); // Debugging response
            setData(response?.data?.[0] || {}); // Store the first object
        } catch (error) {
            console.error("Error fetching contact information:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchcontactinformation();
    }, []);


    const submitHandler = async (values: any) => {
        try {
            let obj = {

                customerName: values.customerName,
                customerEmail: values.customerEmail,
                mobile_number: values.mobile_number,
                customerSubject: values.customerSubject,
                message: values.message,

            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_CONTACT_MESSAGE, obj);

            if (postRequest.status) {
                notification.success({ message: "message send successfully!" });
                form.resetFields();

            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const [showScroll, setShowScroll] = useState(false);

    // Show the button when scrolling down
    useEffect(() => {
        const checkScrollTop = () => {
            if (window.scrollY > 300) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };
        window.addEventListener('scroll', checkScrollTop);
        return () => window.removeEventListener('scroll', checkScrollTop);
    }, []);

    // Scroll to the top when clicking the button
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <div>
            {/* Scroll to Top Button */}
            {showScroll && (
                <button className="scroll-top-button" onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} />
                </button>
            )}
            <Header />
            <div className='contact-page'>
                <div className="about-content">
                    <div className="about-header">
                        <img src={background} alt="About Us Background" />
                        <h1 className="about-title">Contact</h1>
                    </div>
                </div>
                {/* <h3>Contact</h3> */}
                <div className='contact-address-card'>
                    <div className='address-card'>
                        <Card className='address-card-s'>
                            <div className="card-content"> {/* Wrapper div for content */}
                                <FontAwesomeIcon icon={faPhone} style={{ fontSize: "20px", width: "35px", height: "35px" }} />
                                <h5>Phone</h5>
                                <p>
                                    <a href={`https://wa.me/${data?.contactNumber?.replace(/\s+/g, "")}`} target="_blank" rel="noopener noreferrer">
                                        {data?.contactNumber}
                                    </a>
                                </p>
                                <p>
                                    <a href={`https://wa.me/${data?.customer_care_number?.replace(/\s+/g, "")}`} target="_blank" rel="noopener noreferrer">
                                        {data?.customer_care_number}
                                    </a>
                                </p>
                            </div>
                        </Card>

                        <Card className='address-card-s'>
                            <div className="card-content">
                                <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: "20px", width: "35px", height: "35px" }} />
                                <h5>Email</h5>
                                <p><a href={`mailto:${data?.email}`}>{data?.email || "N/A"}</a></p>
                            </div>
                        </Card>

                        <Card className='address-card-s'>
                            <div className="card-content">
                                <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: "20px", width: "35px", height: "35px" }} />
                                <h5>Address</h5>
                                <p>{data?.address || "N/A"}</p>
                            </div>
                        </Card>
                    </div>

                    <br />
                    <div className="row pt-4 px-3">
                        {/* Map Section */}
                        <div className="col-12 col-md-6 mb-4">
                            <h5>Find Our Location</h5>
                            <hr />
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4016664.2864350905!2d73.88326846773326!3d10.538128903653996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0812ffd49cf55b%3A0x64bd90fbed387c99!2sKerala!5e0!3m2!1sen!2sin!4v1660986690327!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                title="Google Maps - Kerala Location"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                        {/* Contact Form Section */}
                        <div className="col-12 col-md-6">
                            <h5>Interested in discussing?</h5>
                            <hr />
                            <Form form={form} onFinish={submitHandler} layout="vertical">
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="customerName"
                                            label="Full Name"
                                            rules={[{ required: true }]}
                                        >
                                            <Input placeholder="Enter your full name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="customerEmail"
                                            label="Email"
                                            rules={[
                                                { required: true, message: "Please enter your email" },
                                                { type: "email", message: "Please enter a valid email" },
                                            ]}
                                        >
                                            <Input type="email" placeholder="Enter your email" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="mobile_number"
                                            label="Contact Number"
                                            rules={[{ required: true }]}
                                        >
                                            <Input placeholder="Enter your contact number" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]}>

                                    <Col xs={24} sm={12}>
                                        <Form.Item
                                            name="customerSubject"
                                            label="Subject"
                                            rules={[{ required: true }]}
                                        >
                                            <Input placeholder="Enter your Subject" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]}>
                                    <Col xs={24}>
                                        <Form.Item
                                            name="message"
                                            label="Message"
                                            rules={[{ required: true }]}
                                        >
                                            <Input.TextArea placeholder="Enter your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Button type="primary" htmlType="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            <FooterWeb />
        </div>
    )
}

export default Contactpage
